const translation = {
  title: 'Esplora',
  sidebar: {
    discovery: 'Scoperta',
    chat: 'Chat',
    workspace: 'Workspace',
    action: {
      pin: 'Fissa',
      unpin: 'Sblocca',
      rename: 'Rinomina',
      delete: 'Elimina',
    },
    delete: {
      title: 'Elimina app',
      content: 'Sei sicuro di voler eliminare questa app?',
    },
  },
  apps: {
    title: 'Esplora App di Dify',
    description:
      'Usa queste app modello istantaneamente o personalizza le tue app basate sui modelli.',
    allCategories: 'Consigliato',
  },
  appCard: {
    addToWorkspace: 'Aggiungi a Workspace',
    customize: 'Personalizza',
  },
  appCustomize: {
    title: 'Crea app da {{name}}',
    subTitle: 'Icona & nome dell\'app',
    nameRequired: 'Il nome dell\'app è obbligatorio',
  },
  category: {
    Assistant: 'Assistente',
    Writing: 'Scrittura',
    Translate: 'Traduzione',
    Programming: 'Programmazione',
    HR: 'Risorse Umane',
    Workflow: 'Flusso di lavoro',
    Agent: 'Agente',
    Entertainment: 'Intrattenimento',
  },
}

export default translation
